import React from "react";
import { useTranslation } from "react-i18next";
import { checkCardNumber, dispatchCusEvent, validateEmail } from "../../utils/utils";

const TEXT_EMPTY = "Fill in this field";
const NOT_VALID_EMAIL = "Enter a valid email address";
const NOT_VALID_CARD = "incorrect card number";
const TEXT_MIN_LENGTH = "Minimum field length ";
const TEXT_MAX_LENGTH = "Maximum field length ";
const MIN_LENGTH = "Minimum value ";
const MAX_LENGTH = "Maximum value ";

const STATUS = {
  isSubmit: true
};

const dispatchEvent = (message, target) => {
  // const event = new CustomEvent("inputError", { detail: { message, target } });
  // window.dispatchEvent(event);
  dispatchCusEvent("inputError", { message, target });
  STATUS.isSubmit = false;
};

const checkMin = (input, t) => {
  const min = input.getAttribute("data-min");
  if (!min || (!+input.value && +input.value !== 0)) return;
  if (+input.value < min) {
    dispatchEvent(t(MIN_LENGTH) + min, input);
  }
};

const checkMax = (input, t) => {
  const max = input.getAttribute("data-max");
  if (!max || !+input.value) return;
  if (+input.value > max) {
    dispatchEvent(t(MAX_LENGTH) + max, input);
  }
};

export default function CusForm({ children, className, onSubmit }) {
  const { t } = useTranslation();

  const onFormSubmit = (e) => {
    e.preventDefault();
    const inputFields = {};
    STATUS.isSubmit = true;

    const getElements = (selector) => e.target.querySelectorAll(selector);

    // FIELD input
    getElements("input").forEach((input) => {
      const name = input.getAttribute("name");
      inputFields[name] = input.value;
    });

    getElements("input[data-type]").forEach((input) => {
      // CHECK_VALID_EMAIL
      const value = input.value;

      if (input.getAttribute("data-type") === "email") {
        if (!validateEmail(value) && value !== "") {
          dispatchEvent(t(NOT_VALID_EMAIL), input);
        }
      } else if (
        input.getAttribute("data-type") === "number" ||
        input.getAttribute("data-type") === "password"
      ) {
        checkMin(input, t);
        checkMax(input, t);
      } else if (input.getAttribute("data-type") === "card") {
        if (!checkCardNumber(value)) {
          dispatchEvent(t(NOT_VALID_CARD), input);
        }
      }
    });

    // CHECK_MIN_LENGTH
    getElements("input[data-minlength]").forEach((input) => {
      const minLength = input.getAttribute("data-minlength");
      if (input.value.length < minLength && input.value !== "") {
        dispatchEvent(t(TEXT_MIN_LENGTH) + minLength, input);
      }
    });

    // CHECK_MAX_LENGTH
    getElements("input[data-maxlength]").forEach((input) => {
      const maxlength = input.getAttribute("data-maxlength");
      if (input.value.length > maxlength && input.value !== "") {
        dispatchEvent(t(TEXT_MAX_LENGTH) + maxlength, input);
      }
    });

    // CHECK_TEXT_EMPTY
    getElements("input[data-required]").forEach((input) => {
      if (input.value === "") dispatchEvent(t(TEXT_EMPTY), input);
    });

    if (STATUS.isSubmit) onSubmit(e, inputFields);
  };

  return (
    <form className={className} onSubmit={onFormSubmit}>
      {children}
    </form>
  );
}
